import React from "react";

const features = [
    {
        name: "AI Grant Writer",
        icon: "smart_toy",
        description: "Leverage cutting-edge AI technology to craft compelling and tailored grant proposals that increase your chances of success.",
    },
    {
        name: "Grant Tracker",
        icon: "track_changes",
        description: "Stay organized and on top of your grant applications with our intuitive tracking system, ensuring you never miss a deadline.",
    },
    {
        name: "Grant Discovery",
        icon: "search",
        description: "Easily find grants that match your organization's needs and goals with our comprehensive grant discovery tools.",
    },
    {
        name: "Community",
        icon: "group",
        description: "Connect with like-minded individuals and professionals in your field, fostering collaboration and knowledge exchange.",
    },
    {
        name: "Grant Organizer",
        icon: "folder",
        description: "Keep all your grant-related documents and information in one secure and easily accessible location.",
    },
    {
        name: "Support",
        icon: "support_agent",
        description: "Get expert assistance and guidance throughout your grant application process from our dedicated support team.",
    }
];

export default function Features() {
    return (
        <section className="py-12 bg-[#C0EFC0]/25 text-center">
            <h2 className="text-5xl font-bold mb-12">Features</h2>
            <div className="max-w-[1100px] mx-auto">
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 px-8">
                    {features.map((f, i) => (
                        <div key={i} className="border border-[#344A56] flex flex-col items-center gap-4 rounded-lg p-6 shadow-sm bg-white">
                            <div className="text-6xl text-white bg-[#202220] rounded-lg h-[64px] w-[64px] flex items-center justify-center">
                                <span className="material-icons text-[28px]">{f.icon}</span></div>
                            <h3 className="text-2xl font-semibold">{f.name}</h3>
                            <p className="text-sm mt-2 pb-8">
                                {f.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
